import {Injectable} from '@nestjs/common'
import {SaleorderprocessType} from '../sale-order-process-type.entity';
import {SaleorderprocessTypeDTO} from './sale-order-process-type.dto';

@Injectable()
export class SaleorderprocessTypeAdapter {
     /**
     * 
     * @param SaleorderprocessTypeDTO
     * @param isUpdate 
     * @returns 
     */

      public convertDtoToEntity( saleorderprocessTypeDTO: SaleorderprocessTypeDTO, isUpdate: boolean = false): SaleorderprocessType {
          const saleorderprocessType = new SaleorderprocessType();
          saleorderprocessType.saleorderprocessTypeId=saleorderprocessTypeDTO.saleorderprocessTypeId;
          saleorderprocessType.saleorderprocessTypeName=saleorderprocessTypeDTO.saleorderprocessTypeName;
          saleorderprocessType.saleorderprocessTypeCode=saleorderprocessTypeDTO.saleorderprocessTypeCode;
          saleorderprocessType.remarks=saleorderprocessTypeDTO.remarks;
            saleorderprocessType.isActive=saleorderprocessTypeDTO.isActive==undefined?true:saleorderprocessTypeDTO.isActive;
            if (isUpdate){
                saleorderprocessType.updatedUser = saleorderprocessTypeDTO.updatedUser;
            }else {
                saleorderprocessType.isActive = true;
                saleorderprocessType.createdUser=saleorderprocessTypeDTO.createdUser;
            }
            return saleorderprocessType;
      }
      public convertEntityToDto ( saleorderprocessTypeData: SaleorderprocessType) : SaleorderprocessTypeDTO{
            const saleorderprocessType = new SaleorderprocessTypeDTO();
          saleorderprocessType.saleorderprocessTypeId=saleorderprocessTypeData.saleorderprocessTypeId;
          saleorderprocessType.saleorderprocessTypeName=saleorderprocessTypeData.saleorderprocessTypeName;
          saleorderprocessType.saleorderprocessTypeCode=saleorderprocessTypeData.saleorderprocessTypeCode;
          saleorderprocessType.remarks=saleorderprocessTypeData.remarks;
          saleorderprocessType.isActive=saleorderprocessTypeData.isActive;
          saleorderprocessType.createdAt=saleorderprocessTypeData.createdAt;
          saleorderprocessType.createdUser=saleorderprocessTypeData.createdUser;
          saleorderprocessType.updatedAt=saleorderprocessTypeData.updatedAt;
          saleorderprocessType.updatedUser=saleorderprocessTypeData.updatedUser;
          saleorderprocessType.versionFlag=saleorderprocessTypeData.versionFlag;
          return saleorderprocessType;

      }


}